export default "__VITE_ASSET__BIfsMHf___"